import React from "react";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ReactComponent as Selected } from "../../../Assets/Images/Selected.svg";
import { ReactComponent as English } from "../../../Assets/Images/language/english.svg";
import { ReactComponent as Spanish } from "../../../Assets/Images/language/spanish.svg";
import { useAuth } from "../../../Store/AuthContext";
import { Theme } from "../../../Style/Theme";
import useErrorMessage from "../../../Utils/Hooks/useErrorMessage";
import { SubHeader4 } from "../../atoms/Typography/SubHeader/SubHeader";
import { Text8 } from "../../atoms/Typography/Text/Text";
import { FormItemsWrap } from "../Wrap/Wrap";

export const LanguageSelection = ({ onClick }) => {
  const { state, dispatch } = useAuth();
  const { t, i18n } = useTranslation(["glossary"]);

  const { error, showError, hideError } = useErrorMessage();

  const changeLanguage = (code) => {
    if (error.show) {
      hideError();
    }
    i18n.changeLanguage(code);
    dispatch({
      type: "SELECT_LANG",
      payload: code,
    });
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <FormItemsWrap
          justifyContent={"center"}
          alignItems={"start"}
          direction={"row"}
          gap={"60px"}
        >
          <FormItemsWrap
            direction={"row"}
            alignItems={"center"}
            showPointer
            onClick={() => changeLanguage("en")}
          >
            <SubHeader4
              color={"text.gray"}
              icongap={"12px"}
              icon={<English role="img" type="img" aria-label="English Flag" />}
              text={t("auth.language.en")}
            />
            {state.lang.code === "en" && (
              <Selected
                role="img"
                type="img"
                aria-label="Selected Icon"
                style={{ marginLeft: "12px" }}
              />
            )}
          </FormItemsWrap>
          {/* <FormItemsWrap
            showPointer
            onClick={() => changeLanguage("es")}
            direction={"row"}
            alignItems={"center"}
          >
            <SubHeader4
              color={"text.gray"}
              icongap={"12px"}
              icon={<Spanish role="img" type="img" aria-label="Spanish Flag" />}
              text={t("auth.language.es")}
            />
            {state.lang.code === "es" && (
              <Selected style={{ marginLeft: "12px" }} />
            )}
          </FormItemsWrap> */}
        </FormItemsWrap>
        {error.show && (
          <>
            <Text8
              mTop={"12px"}
              color={Theme.palette.text.pink}
              text={t(error.message, { ns: "validation", lng: "es" })}
            />
            <Text8
              mTop={"4px"}
              color={Theme.palette.text.pink}
              text={t(error.message, { ns: "validation", lng: "en" })}
            />
          </>
        )}
      </div>

      <FormItemsWrap justifyContent={"center"} direction={"row"}>
        <Button
          onClick={() => {
            if (state.lang.code) {
              onClick(state.lang.code);
            } else {
              showError("required-lang");
            }
          }}
          variant="primaryBlue"
          style={{ width: "350px" }}
        >
          {t("common:button.get-started")}
        </Button>
      </FormItemsWrap>
    </>
  );
};
